import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Form, Row, Button, Col, Accordion } from "react-bootstrap";
import DatePicker from "~/components/DatePicker";
import Dropdown from "~/components/Dropdown";

const Filters = ({
  active,
  handleCall,
  buildGrouUserList,
  handleDropdownSelect,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  groupSelected,
  setGroupSelected,
  t,
}) => {
  const [cleanDropdown, setCleanDropdown] = useState(false);

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    setCleanDropdown(true);
    setGroupSelected(null)
  };

  return (
    <Accordion activeKey={active ? "0" : ""}>
      <Accordion.Collapse eventKey="0">
        <Form>
          <>
            <Row>
              <Col>
                <Form.Label>
                  {t("portalrh.rhadmin.integracao.startDate")}
                </Form.Label>
                <DatePicker
                  value={startDate}
                  onChange={(e) => setStartDate(e)}
                  format="dd/MM/yyyy"
                />
              </Col>
              <Col>
                <Form.Label>
                  {t("portalrh.rhadmin.integracao.endDate")}
                </Form.Label>
                <DatePicker
                  value={endDate}
                  onChange={(e) => setEndDate(e)}
                  format="dd/MM/yyyy"
                />
              </Col>
              <Col>
                <Form.Label style={{ paddingLeft: "10px" }}>
                  {t("portalrh.rhadmin.integracao.groups")}
                </Form.Label>
                <Dropdown
                  placeholder={t("portalrh.rhadmin.integracao.selectOption")}
                  emptyDefault={true}
                  required={true}
                  list={buildGrouUserList()}
                  handleSubmit={(submitValue) =>
                    handleDropdownSelect(submitValue)
                  }
                  resetDropdown={cleanDropdown}
                  setResetDropdown={setCleanDropdown}
                  defaultValue={
                    groupSelected ? groupSelected : ""
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{ display: "flex", gap: "2rem" }}>
                  <Button
                  id="button_rhadmin_integration_filters_search"
                    className="card-button"
                    onClick={() => handleCall("1")}
                  >
                    {t("portalrh.rhadmin.integracao.calcfaltinjust")}
                  </Button>
                  <Button id="button_rhadmin_integration_filters_clean" className="card-button" onClick={handleReset}>
                    {t("general.clean")}
                  </Button>
                </div>
              </Col>
            </Row>
          </>
        </Form>
      </Accordion.Collapse>
    </Accordion>
  );
};

export default withNamespaces()(Filters);
